export default __webpack_public_path__ + "static/media/section-four2.5ec6f246.jpg";